module.exports = __webpack_public_path__ + "img/icon-financial.34675b28.svg";